import React from 'react';

export const COMPANY_REVIEWS_SLIDES = [
    {
        user: {
            src: '/v1550269383/userImages/review_avatar_1.png',
            alt: 'review one',
        },
        company: {
            name: 'Boston Scientific',
            url: '/company-overview/boston-scientific',
        },
        quote: (
            <div>
                <span className={'highlight'}>"There is great flexibility</span>{' '}
                and support for your work and life aspirations."
            </div>
        ),
        rating: '5.0',
        equality: 'Yes',
    },
    {
        user: {
            src: '/v1550269383/userImages/review_avatar_2.png',
            alt: '',
        },
        company: {
            name: 'Linkedin',
            url: '/company-overview/linkedin',
        },
        quote: (
            <div>
                "At the higher levels{' '}
                <span className="highlight">it is a very bro culture."</span>
            </div>
        ),
        rating: '4.0',
        equality: 'Yes',
    },
    {
        user: {
            src: '/v1550269383/userImages/review_avatar_3.png',
            alt: '',
        },
        company: {
            name: 'Moog, Inc.',
            url: '/company-overview/moog-inc',
        },
        quote: (
            <div>
                "You might be surrounded by{' '}
                <span className="highlight">men that don't respect women</span>{' '}
                as equal to them."
            </div>
        ),
        rating: '5.0',
        equality: 'No',
    },
    {
        user: {
            src: '/v1550269383/userImages/review_avatar_4.png',
            alt: '',
        },
        company: {
            name: 'One Kings Lane',
            url: '/company-overview/one-kings-lane',
        },
        quote: (
            <div>
                <span className="highlight">
                    "Favoritism plays into promotions
                </span>{' '}
                and you’re expected to always be online."
            </div>
        ),
        rating: '1.0',
        equality: 'Yes',
    },
    {
        user: {
            src: '/v1550269383/userImages/review_avatar_5.png',
            alt: '',
        },
        company: {
            name: 'Goldman Sachs',
            url: '/company-overview/goldman-sachs',
        },
        quote: (
            <div>
                "They are working hard to{' '}
                <span className="highlight">get more women</span> on top"
            </div>
        ),
        rating: '4.0',
        equality: 'Yes',
    },
];

export const mockSalaryPercentages = [
    {
        title: '$0-$25k',
        value: 9,
    },
    {
        title: '$25k-$50k',
        value: 47,
    },
    {
        title: '$50k-$80k',
        value: 78,
    },
    {
        title: '$80k-$100k',
        value: 100,
    },
    {
        title: '$100k-$150k',
        value: 32,
    },
    {
        title: '>$150k',
        value: 20,
    },
];
